import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EndUserIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M12,11.47c-1.84-.69-2.42-1.28-2.42-2.53,0-.75.56-.5.81-1.88.1-.57.59,0,.7-1.32,0-.52-.27-.65-.27-.65s.13-.77.19-1.36-.42-2.64-3-2.64S5,3,5,3.73s.19,1.36.19,1.36S5,5.22,5,5.74c.1,1.31.59.74.7,1.32.24,1.37.8,1.13.8,1.88,0,1.26-.58,1.85-2.42,2.54s-3,1.4-3,1.88V15H15V13.36C15,12.88,13.8,12.17,12,11.47Z"
    />
  ]
  getViewBox = () => '0 0 16 16'
}